import { Button, ButtonProps, CircularProgress, Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { ReactElement } from 'react';

export interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
  withPadding?: boolean;
}

export const LoadingButton = (props: LoadingButtonProps): ReactElement => {
  const { isLoading, withPadding, disabled, children, ...other } = props;

  return (
    <Button disabled={disabled || isLoading} {...other}>
      <Grid
        container={true}
        justifyContent={'center'}
        position={'relative'}
        padding={(theme: Theme): string => (withPadding ? theme.spacing(0, 4) : 'initial')}>
        {isLoading && (
          <Grid item={true} sx={{ position: 'absolute', left: 0 }}>
            <CircularProgress color={'inherit'} size={20} />
          </Grid>
        )}
        <Grid item={true}>{children}</Grid>
      </Grid>
    </Button>
  );
};
